import { render, staticRenderFns } from "./ThumbnailAttachments.vue?vue&type=template&id=7c015957&scoped=true"
import script from "./ThumbnailAttachments.vue?vue&type=script&lang=js"
export * from "./ThumbnailAttachments.vue?vue&type=script&lang=js"
import style0 from "./ThumbnailAttachments.vue?vue&type=style&index=0&id=7c015957&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c015957",
  null
  
)

export default component.exports